
import { Ticket } from "@/models/ticket";
import { TicketService } from "@/services/ticket-service";
import Vue from "vue";

export default Vue.extend({
	props: {
		ticket: {
			type: Object as ()=>Ticket,
			required: true
		}
	},
	computed: {
		checked():boolean{
			return this.ticket.isBookmarked();
		},
		iconPrefix():string {
			if (this.checked) {
				return "fas";
			}
			return "far";
		}
	},
	methods: {
		async onClick(){
			if (this.ticket.isBookmarked()){
				await TicketService.unBookmark(this.ticket);
			}else{
				await TicketService.bookmark(this.ticket);
			}
		}
	}
});
